import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

/**
 * @deprecated Use `SwiftConnectDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { SwiftConnectDefinition } from 'application-types';`
 */
export const SwiftConnectDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.SwiftConnect,
  hasCustomUI: true,
  friendlyName: 'SwiftConnect Access Control',
  description: `Defines the properties required for a SwiftConnect integration.`,
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {},
};
